<script setup lang="ts">
import { useAd } from '../../advertisement/composables/use-ad'
import AdSlot from './AdSlot.vue'

const { slotName, minWidth, minHeight } = useAd('side', 0)
</script>

<template>
  <AdSlot v-if="slotName"
          :min-width="minWidth"
          :min-height="minHeight"
          :slot-name="slotName"
          tw-class="sticky top-[104px] w-full" />
</template>
